function waitForElm(selectors) {
    return new Promise(resolve => {
        var k = 0;

        do {
            if (document.querySelector(selectors[k])) {
                selectors.splice(k, 1);
                k = -1;
            }

            k++;
        } while (k < selectors.length);

        if (selectors.length === 0) {
            return resolve();
        }

        const observer = new MutationObserver(() => {
            var i = 0;

            do {
                if (document.querySelector(selectors[i])) {
                    selectors.splice(i, 1);
                    i = i - 1;
                }

                i++;
            } while (i < selectors.length);

            if (selectors.length === 0) {
                observer.disconnect();
                resolve();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


/* ========================================
   OVERLAYS / WIDGETS
======================================== */

function clavToggleNode(mutation, node) {

    if (!node || !mutation.target) {
        return;
    }

    const className = mutation.target.className.toString();

    if (
        className.includes('open') ||
        className.includes('sidebar--opened')
    ) {
        node.style.opacity = 0;
    } else {
        node.style.opacity = 1;
    }
}


function initObserver(observerableNode, nodeToToggle) {

    waitForElm([observerableNode, nodeToToggle]).then(() => {

        const observableElement = document.querySelector(observerableNode);
        const toggleElement = document.querySelector(nodeToToggle);

        if (!observableElement || !toggleElement) {
            return;
        }

        function cartOpenCallback(mutationsList) {

            mutationsList.forEach(mutation => {

                if (mutation.attributeName === 'class') {
                    clavToggleNode(mutation, toggleElement);
                }

            });
        }

        const cartMutationObserver =
            new MutationObserver(cartOpenCallback);

        cartMutationObserver.observe(
            observableElement,
            {
                attributes: true,
                attributeFilter: ['class']
            }
        );
    });
}


const slideCartNode = '.slidecarthq';
const slideCartNodeAlt = '#site-cart-sidebar';
const smileNode = '#smile-ui-lite-container';
const trustedShops = "[id^='trustbadge-container-']";
const dummyChatBotNode = '#dummy-chat-button-iframe';
const menuNode = '#site-menu-sidebar';


initObserver(slideCartNode, smileNode);
initObserver(slideCartNode, trustedShops);
initObserver(slideCartNode, dummyChatBotNode);

initObserver(slideCartNodeAlt, smileNode);
initObserver(slideCartNodeAlt, trustedShops);
initObserver(slideCartNodeAlt, dummyChatBotNode);

initObserver(menuNode, smileNode);
initObserver(menuNode, trustedShops);
initObserver(menuNode, dummyChatBotNode);


/* ========================================
   LIEFERZEIT
======================================== */

function updateDufteDeliveryDate() {

    const deliveryElements =
        document.querySelectorAll('[data-dufte-delivery-date]');

    if (!deliveryElements.length) {
        return;
    }

    const now = new Date();

    const shippingDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        12,
        0,
        0
    );

    const currentDay = now.getDay();
    const currentHour = now.getHours();


    /* ========================================
       VERSANDTAG

       Mo–Fr vor 14 Uhr:
       Versand heute

       Mo–Fr ab 14 Uhr:
       Versand nächster Werktag

       Sa/So:
       Versand Montag
    ======================================== */

    if (currentDay === 6) {

        // Samstag → Montag
        shippingDate.setDate(
            shippingDate.getDate() + 2
        );

    } else if (currentDay === 0) {

        // Sonntag → Montag
        shippingDate.setDate(
            shippingDate.getDate() + 1
        );

    } else if (currentHour >= 14) {

        // Nach 14 Uhr → nächster Tag
        shippingDate.setDate(
            shippingDate.getDate() + 1
        );

        // Samstag → Montag
        if (shippingDate.getDay() === 6) {
            shippingDate.setDate(
                shippingDate.getDate() + 2
            );
        }

        // Sonntag → Montag
        if (shippingDate.getDay() === 0) {
            shippingDate.setDate(
                shippingDate.getDate() + 1
            );
        }
    }


    /* ========================================
       FRÜHESTES LIEFERDATUM
       +1 Tag nach Versand
    ======================================== */

    const earliestDelivery =
        new Date(shippingDate);

    earliestDelivery.setDate(
        earliestDelivery.getDate() + 1
    );

    // Keine Sonntagszustellung
    if (earliestDelivery.getDay() === 0) {
        earliestDelivery.setDate(
            earliestDelivery.getDate() + 1
        );
    }


    /* ========================================
       SPÄTESTES LIEFERDATUM
       +2 Tage nach Versand
    ======================================== */

    const latestDelivery =
        new Date(shippingDate);

    latestDelivery.setDate(
        latestDelivery.getDate() + 2
    );

    // Keine Sonntagszustellung
    if (latestDelivery.getDay() === 0) {
        latestDelivery.setDate(
            latestDelivery.getDate() + 1
        );
    }


    /* ========================================
       FORMATIERUNG
    ======================================== */

    const weekdays = [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ];

    function formatDeliveryDate(date) {

        return (
            weekdays[date.getDay()] +
            ' ' +
            date.getDate() +
            '.' +
            (date.getMonth() + 1) +
            '.'
        );
    }


    const deliveryText =
        'ca. ' +
        formatDeliveryDate(earliestDelivery) +
        ' – ' +
        formatDeliveryDate(latestDelivery);


    /* ========================================
       AUSGABE
    ======================================== */

    deliveryElements.forEach(element => {

        // Nur ändern, wenn notwendig.
        // Verhindert unnötige MutationObserver-Loops.

        const elementDeliveryText = element.dataset.dufteDeliveryFormat === 'product'
            ? 'Bei Dir zu Hause zwischen ' + formatDeliveryDate(earliestDelivery) + ' und ' + formatDeliveryDate(latestDelivery)
            : deliveryText;

        if (element.textContent.trim() !== elementDeliveryText) {
            element.textContent = elementDeliveryText;
        }

    });
}


/* ========================================
   CART DRAWER ÜBERWACHEN
======================================== */

function initDufteDeliveryObserver() {

    const cartDrawer =
        document.querySelector('#site-cart-sidebar');

    if (!cartDrawer) {
        return;
    }


    let updateScheduled = false;


    function scheduleDeliveryUpdate() {

        // Verhindert, dass bei einem einzigen
        // Cart-Update 20 Berechnungen stattfinden.

        if (updateScheduled) {
            return;
        }

        updateScheduled = true;


        requestAnimationFrame(() => {

            updateScheduled = false;

            updateDufteDeliveryDate();

        });

    }


    const observer =
        new MutationObserver(() => {

            scheduleDeliveryUpdate();

        });


    observer.observe(
        cartDrawer,
        {
            childList: true,
            subtree: true,
            characterData: true
        }
    );


    /* Initial berechnen */

    scheduleDeliveryUpdate();


    /* Zusätzlich beim Öffnen des Drawers */

    const drawerClassObserver =
        new MutationObserver(() => {

            scheduleDeliveryUpdate();

        });


    drawerClassObserver.observe(
        cartDrawer,
        {
            attributes: true,
            attributeFilter: ['class', 'style']
        }
    );

}


/* ========================================
   START
======================================== */

function initDufteDelivery() {

    updateDufteDeliveryDate();

    initDufteDeliveryObserver();

}


if (document.readyState === 'loading') {

    document.addEventListener(
        'DOMContentLoaded',
        initDufteDelivery
    );

} else {

    initDufteDelivery();

}

/* Homepage: automatischer Bildwechsel alle 5 Sekunden. */
(function () {
    const selector = '.template-index .mount-slideshow css-slider';
    const instances = new Map();

    function initHomepageSlideshow() {
        const slider = document.querySelector(selector);
        if (!slider || instances.has(slider) || !slider.sliderEnabled || slider.length < 2) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const events = new AbortController();
        const options = { signal: events.signal };
        let hovered = false;
        let touching = false;
        let visible = false;
        let timer;

        function schedule() {
            window.clearTimeout(timer);
            const focused = slider.contains(document.activeElement);
            if (motion.matches || hovered || touching || focused || !visible || document.hidden || !slider.isConnected) return;
            timer = window.setTimeout(function () {
                if (!slider.isConnected || slider.length < 2) return;
                slider.changeSlide((slider.index + 1) % slider.length);
                schedule();
            }, 5000);
        }
        slider.addEventListener('pointerenter', function (event) {
            if (event.pointerType === 'mouse') { hovered = true; schedule(); }
        }, options);
        slider.addEventListener('pointerleave', function () { hovered = false; schedule(); }, options);
        slider.addEventListener('pointerdown', function () { touching = true; schedule(); }, options);
        function releasePointer() {
            if (touching) { touching = false; schedule(); }
        }
        document.addEventListener('pointerup', releasePointer, options);
        document.addEventListener('pointercancel', releasePointer, options);
        slider.addEventListener('focusin', schedule, options);
        slider.addEventListener('focusout', function () { queueMicrotask(schedule); }, options);
        slider.addEventListener('change', schedule, options);
        slider.addEventListener('scroll', schedule, options);
        document.addEventListener('visibilitychange', schedule, options);
        motion.addEventListener('change', schedule, options);
        const observer = new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
            schedule();
        }, { threshold: [0, 0.1] });
        observer.observe(slider);
        instances.set(slider, function () {
            window.clearTimeout(timer);
            events.abort();
            observer.disconnect();
        });
    }

    function start() {
        if (!window.customElements) return;
        customElements.whenDefined('css-slider').then(initHomepageSlideshow);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:section:unload', function (event) {
        instances.forEach(function (cleanup, slider) {
            if (event.target.contains(slider)) { cleanup(); instances.delete(slider); }
        });
    });
})();

/* PDP: align the visible manufacturer logo, including padded image files. */
(function () {
  const selector = '.dufte-product-brand__image';
  const alignedSources = new WeakMap();

  function alignLogo(image) {
    if (!image.complete || !image.naturalWidth) return;
    const source = image.currentSrc || image.src;
    if (alignedSources.get(image) === source) return;
    alignedSources.set(image, source);
    image.style.removeProperty('--dufte-logo-offset');

    try {
      const canvas = document.createElement('canvas');
      canvas.width = 480;
      canvas.height = Math.max(1, Math.round(480 * image.naturalHeight / image.naturalWidth));
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      let left = canvas.width;
      for (let y = 0; y < canvas.height; y += 1) {
        for (let x = 0; x < left; x += 1) {
          const i = (y * canvas.width + x) * 4;
          // Ignore transparent or white padding on the product's white background.
          if (pixels[i + 3] > 16 && Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) < 248) {
            left = x;
            break;
          }
        }
      }
      if (left < canvas.width) {
        image.style.setProperty('--dufte-logo-offset', (-100 * left / canvas.width) + '%');
      }
    } catch (error) {
      // Keep the original image visible if its pixels cannot be read.
    }
  }

  function alignLogos(root) {
    root.querySelectorAll(selector).forEach(alignLogo);
  }
  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) alignLogo(event.target);
  }, true);
  document.addEventListener('shopify:section:load', function (event) { alignLogos(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alignLogos(document); }, { once: true });
  } else {
    alignLogos(document);
  }
})();

/* PDP benefits: follow Combine's variant availability without replacing its form. */
(function () {
  const initialized = new WeakSet();
  function syncAvailability(page, variant) {
    const available = Boolean(variant && variant.available);
    page.querySelectorAll('[data-dufte-pdp-stock], [data-dufte-usp-delivery]').forEach(function (element) {
      element.hidden = !available;
    });
    page.querySelectorAll('[data-dufte-usp-unavailable]').forEach(function (element) {
      element.hidden = available;
      element.textContent = variant ? 'Aktuell nicht lieferbar' : 'Bitte Variante wählen';
    });
    updateDufteDeliveryDate();
  }
  function init(root) {
    root.querySelectorAll('product-page').forEach(function (page) {
      const variants = page.querySelector('product-variants');
      if (!variants || !page.querySelector('.dufte-product-benefits') || initialized.has(variants)) return;
      initialized.add(variants);
      variants.addEventListener('VARIANT_CHANGE', function (event) {
        syncAvailability(page, event.target.currentVariant);
      });
    });
    updateDufteDeliveryDate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
